import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountUserInfo" })
export default class AccountUserInfo extends Vue {
    public localizer: any = Localizer;
    public profileInfo: any = { email: null, isCompany: false };

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        const result = (await Axios.post(this.routes.Account_User_GetUserInfo)).data;
        this.profileInfo.email = result.email;
        this.profileInfo.name = result.name;
        this.profileInfo.surname = result.surname;
        this.profileInfo.isCompany = result.isCompany;
        this.profileInfo.firstLetters = result.firstLetters;
    }
};